module.exports = __webpack_public_path__ + "static/media/cases_brand_riovermelho_02.f6a3fed4.jpg";